import { NewOfferCost, ResiliationFormulaState } from '../types';
import { computeRemainingMonths } from './utils';

export default function computeNewOfferCost(state: ResiliationFormulaState): NewOfferCost | undefined {
  if (state.newOffer === undefined) return undefined;
  const offer = state.newOffer;
  const remainingMonths = computeRemainingMonths(state.commitmentDuration, state.startDate) ?? 12;
  const firstYearMonths = Math.min(remainingMonths, 12);
  const firstYear = {
    monthly: offer.firstYear,
    months: firstYearMonths,
    total: offer.firstYear * firstYearMonths,
  };

  const secondYearMonths = Math.max(remainingMonths - 12, 0);
  const secondYear = !secondYearMonths ? undefined : {
    monthly: offer.secondYear ?? offer.firstYear,
    months: secondYearMonths,
    total: (offer.secondYear ?? offer.firstYear) * secondYearMonths,
  };

  return {
    firstYear,
    ...secondYear && { secondYear },
    setupFee: offer.setupFees,
    total: firstYear.total + (secondYear?.total ?? 0) + (offer.setupFees ?? 0),
  };
}
